import React from "react";
import { HistoryItem } from "./HistoryItem";

export const HistoryGroupItem = (props) => {
  return (
    <div className="main-item-wrapper">
      <div className="header">
        <b>{props.heading}</b>
      </div>
      <ul className="history-content-list" type="none">
        {props.data.map((item, index) => {
          return (
            <li key={index}>
              <HistoryItem
                heading={item.heading}
                time={item.time}
                title={item.title}
                description={item.description}
                web_link={item.web_link}
                links={item.links}
                postings={item.postings}
              />
            </li>
          );
        })}
      </ul>
    </div>
  );
};
